// Enhanced mock data for cellrox - All device repair services

export const allServices = [
  {
    id: 1,
    category: "iPhone",
    name: "iPhone Screen Replacement",
    description: "Crystal-clear display restoration for all iPhone models",
    icon: "Smartphone",
    image: "https://images.unsplash.com/photo-1673713234831-bff865b62328?w=400",
    time: "25-45 min"
  },
  {
    id: 2,
    category: "iPhone",
    name: "iPhone Battery Replacement",
    description: "Restore your iPhone's all-day battery life",
    icon: "Battery",
    image: "https://images.unsplash.com/photo-1525446517618-9a9e5430288b?w=400",
    time: "20-30 min"
  },
  {
    id: 3,
    category: "Android",
    name: "Samsung & Android Repair",
    description: "Expert repair for all Android devices",
    icon: "Smartphone",
    image: "https://images.unsplash.com/photo-1701118855521-b9cfa88170aa?w=400",
    time: "30-60 min",
    devices: "Samsung Galaxy, Google Pixel, OnePlus, and more"
  },
  {
    id: 4,
    category: "iPad",
    name: "iPad Screen & Battery Repair",
    description: "Professional iPad repair for all generations",
    icon: "Tablet",
    image: "https://images.unsplash.com/photo-1643509098169-8b810b1dc991?w=400",
    time: "45-90 min",
    devices: "iPad Pro, iPad Air, iPad Mini"
  },
  {
    id: 5,
    category: "MacBook",
    name: "MacBook Screen & Logic Board",
    description: "Precision MacBook repairs by certified technicians",
    icon: "Laptop",
    image: "https://images.unsplash.com/photo-1640551497504-ec05b9e50b50?w=400",
    time: "1-3 hours",
    devices: "MacBook Air, MacBook Pro, all models"
  },
  {
    id: 6,
    category: "Laptop",
    name: "Windows Laptop Repair",
    description: "Complete repair solutions for all laptop brands",
    icon: "Monitor",
    image: "https://images.unsplash.com/photo-1683995781335-aea2678991bb?w=400",
    time: "1-2 hours",
    devices: "Dell, HP, Lenovo, ASUS, and more"
  },
  {
    id: 7,
    category: "Quick Fix",
    name: "Charging Port Repair",
    description: "Fast charging port replacement for all devices",
    icon: "Cable",
    time: "30-45 min"
  },
  {
    id: 8,
    category: "Quick Fix",
    name: "Water Damage Recovery",
    description: "Emergency water damage restoration service",
    icon: "Droplets",
    time: "1-2 hours"
  }
];

export const mockGallery = [
  {
    id: 1,
    before: "https://images.unsplash.com/photo-1746006084492-24a8fd02710a?w=400",
    after: "https://images.unsplash.com/photo-1623385245725-2c39e44567e5?w=400",
    description: "Shattered iPhone Screen → Perfect Display"
  },
  {
    id: 2,
    before: "https://images.unsplash.com/photo-1731391777974-18f9adb69490?w=400",
    after: "https://images.unsplash.com/photo-1570894808314-677b57f25e45?w=400",
    description: "Broken Phone Display → Like New"
  },
  {
    id: 3,
    before: "https://images.pexels.com/photos/288479/pexels-photo-288479.jpeg?w=400",
    after: "https://images.unsplash.com/photo-1709652880879-3b8e144eafe2?w=400",
    description: "Cracked Screen Repair → Pristine Condition"
  }
];

export const blogPosts = [
  {
    id: 1,
    slug: "iphone-screen-repair-mississauga",
    title: "iPhone Screen Repair in Mississauga: Complete Guide 2025",
    excerpt: "Everything you need to know about iPhone screen replacement near you. Fast, affordable, and backed by warranty.",
    image: "https://images.unsplash.com/photo-1673713234831-bff865b62328?w=800",
    category: "iPhone Repair",
    author: "cellrox Tech Team",
    date: "2025-02-06",
    readTime: "5 min read",
    seoKeywords: "iPhone screen repair Mississauga, iPhone repair near me, screen replacement",
    content: `
# iPhone Screen Repair in Mississauga: Your Complete Guide

Is your iPhone screen cracked or unresponsive? You're not alone. At **cellrox** inside Walmart Matheson, we repair hundreds of iPhone screens every month. Here's everything you need to know.

## Why Choose Professional Repair?

✅ **90-Day Warranty** - All repairs guaranteed  
✅ **Same-Day Service** - Most repairs in 30-60 minutes  
✅ **OEM Quality Parts** - No cheap alternatives  
✅ **Expert Technicians** - Certified and experienced  

## iPhone Screen Repair Pricing 2025

- iPhone 15 Pro Max: $449
- iPhone 15 Pro: $429
- iPhone 15: $379
- iPhone 14 Series: $349-$399
- iPhone 13: $299
- Older Models: $229+

## How Long Does It Take?

Most iPhone screen replacements take **25-45 minutes**. Walk in or book online at [iphonerepairnearme.ca](https://iphonerepairnearme.ca).

## Location: Inside Walmart Matheson

📍 800 Matheson Blvd West, Mississauga  
⏰ Monday-Sunday: 10 AM - 10 PM  
📞 905-699-6599 | 647-997-6390

## Why cellrox?

We're not just another repair shop. We're **inside Walmart** - shop while we fix! Plus, our **lifetime customer support** means we're here long after the repair.

Book your iPhone screen repair today!
    `
  },
  {
    id: 2,
    slug: "macbook-repair-near-me",
    title: "MacBook Repair Mississauga: Screen, Battery, Logic Board",
    excerpt: "Professional MacBook repair services for all models. Expert technicians, genuine parts, fast turnaround.",
    image: "https://images.unsplash.com/photo-1640551497504-ec05b9e50b50?w=800",
    category: "MacBook Repair",
    author: "cellrox Tech Team",
    date: "2025-02-06",
    readTime: "6 min read",
    seoKeywords: "MacBook repair Mississauga, MacBook screen replacement, MacBook battery",
    content: `
# MacBook Repair in Mississauga: Expert Service at cellrox

Your MacBook is essential for work, school, and creativity. When it needs repair, trust the experts at **cellrox** inside Walmart Matheson.

## Common MacBook Issues We Fix

### 1. **MacBook Screen Replacement**
Cracked or flickering display? We replace MacBook screens for all models:
- MacBook Air (M1, M2, M3)
- MacBook Pro 13" & 14"
- MacBook Pro 16"

**Price**: Starting at $299  
**Time**: 1-3 hours

### 2. **MacBook Battery Replacement**
Not holding a charge? We install genuine battery replacements.

**Price**: $179-$299  
**Time**: 1-2 hours

### 3. **Logic Board Repair**
Won't turn on? Liquid damage? We specialize in logic board diagnostics and repair.

**Price**: From $299 (diagnosis included)  
**Time**: 2-4 hours

## Why Choose cellrox for MacBook Repair?

✅ **Certified Technicians** - Apple-trained experts  
✅ **Genuine Apple Parts** - No knockoffs  
✅ **Data Protection** - Your privacy matters  
✅ **90-Day Warranty** - Peace of mind included  

## Convenient Location

Inside Walmart at 800 Matheson Blvd West. Shop while we repair!

**Hours**: 10 AM - 10 PM Daily  
**Contact**: [iphonerepairnearme.ca](https://iphonerepairnearme.ca)

Book your MacBook repair online or walk in today!
    `
  },
  {
    id: 3,
    slug: "ipad-screen-repair-guide",
    title: "iPad Screen Repair Mississauga: Fast & Affordable",
    excerpt: "Cracked iPad screen? Get it fixed today at cellrox. All iPad models serviced with warranty.",
    image: "https://images.unsplash.com/photo-1643509098169-8b810b1dc991?w=800",
    category: "iPad Repair",
    author: "cellrox Tech Team",
    date: "2025-02-05",
    readTime: "4 min read",
    seoKeywords: "iPad screen repair, iPad repair Mississauga, tablet repair near me",
    content: `
# iPad Screen Repair in Mississauga: Quick & Reliable

Dropped your iPad? Screen cracked? **cellrox** at Walmart Matheson provides expert iPad screen repair for all models.

## iPad Models We Repair

- iPad Pro (11" & 12.9")
- iPad Air (all generations)
- iPad Mini
- Standard iPad (all models)

## iPad Screen Repair Pricing

**Starting at $199**  
Time: 45-90 minutes

## Why Repair vs. Replace?

New iPad Pro: $1,299+  
**Screen Repair: $199-$399** ✅

Save $900+ by repairing!

## What's Included

✅ Free diagnostic  
✅ High-quality replacement screen  
✅ 90-day warranty  
✅ Same-day service  
✅ Professional installation  

## Book Your iPad Repair

📍 Inside Walmart, 800 Matheson Blvd W  
⏰ 10 AM - 10 PM, 7 Days/Week  
📱 Visit [iphonerepairnearme.ca](https://iphonerepairnearme.ca)

Don't let a cracked screen stop you. Get it fixed today!
    `
  },
  {
    id: 4,
    slug: "phone-water-damage-repair",
    title: "Water Damage Repair: Can Your Phone Be Saved?",
    excerpt: "Dropped your phone in water? Act fast! Learn what to do and how cellrox can help recover water-damaged devices.",
    image: "https://images.unsplash.com/photo-1768633647910-7e6fb53e5b0f?w=800",
    category: "Repair Tips",
    author: "cellrox Tech Team",
    date: "2025-02-04",
    readTime: "5 min read",
    seoKeywords: "water damage repair, phone water damage, wet phone fix",
    content: `
# Water Damage Repair: Save Your Wet Phone

Water + Electronics = Panic. But don't worry! **cellrox** specializes in water damage recovery for phones, tablets, and laptops.

## Immediate Steps (First 5 Minutes)

1. **Turn Off Device** - Don't charge it!
2. **Remove Case & SIM** - Let air circulate
3. **Dry Exterior** - Pat with towel
4. **Don't Use Rice** - Bring it to us ASAP!

## Our Water Damage Recovery Process

### 1. **Diagnostic (Free)**
We inspect internal components for damage.

### 2. **Ultrasonic Cleaning**
Professional cleaning removes water and corrosion.

### 3. **Component Repair**
We repair or replace damaged parts.

### 4. **Testing**
Full functionality testing before return.

**Price**: Starting at $149  
**Time**: 1-2 hours (most cases)

## Success Rate

📊 **85% recovery rate** when brought in within 24 hours!

## What Can Be Recovered?

✅ iPhone, Samsung, Google Pixel  
✅ iPad and tablets  
✅ MacBook and laptops  
✅ Data recovery available  

## Prevention Tips

- Use waterproof case
- Keep away from bathroom/kitchen
- Invest in water-resistant phone

## Emergency Water Damage Service

**Walk-ins welcome!**  
📍 800 Matheson Blvd W (inside Walmart)  
📞 905-699-6599  
⏰ Open 10 AM - 10 PM Daily

Visit [iphonerepairnearme.ca](https://iphonerepairnearme.ca) for instant booking!
    `
  },
  {
    id: 5,
    slug: "laptop-repair-mississauga",
    title: "Laptop Repair Mississauga: Dell, HP, Lenovo & More",
    excerpt: "Professional laptop repair for all brands. Screen, keyboard, battery, and motherboard repairs with warranty.",
    image: "https://images.unsplash.com/photo-1683995781335-aea2678991bb?w=800",
    category: "Laptop Repair",
    author: "cellrox Tech Team",
    date: "2025-02-03",
    readTime: "6 min read",
    seoKeywords: "laptop repair Mississauga, Windows laptop fix, Dell HP repair",
    content: `
# Professional Laptop Repair in Mississauga

Is your laptop slow, broken, or not charging? **cellrox** repairs all laptop brands at our Walmart Matheson location.

## Brands We Service

- Dell (Inspiron, XPS, Latitude)
- HP (Pavilion, Envy, EliteBook)
- Lenovo (ThinkPad, IdeaPad, Yoga)
- ASUS, Acer, Microsoft Surface
- Gaming Laptops (Razer, Alienware, MSI)

## Common Laptop Repairs

### 1. **Screen Replacement**
Cracked or dark screen? We replace all laptop screens.  
**Price**: $149-$349 | **Time**: 1-2 hours

### 2. **Keyboard Replacement**
Sticky keys or liquid damage?  
**Price**: $79-$149 | **Time**: 45-60 min

### 3. **Battery Replacement**
Won't hold charge?  
**Price**: $89-$199 | **Time**: 30-60 min

### 4. **SSD/HDD Upgrade**
Speed up your laptop with SSD upgrade!  
**Price**: $149+ | **Time**: 1 hour

### 5. **Motherboard Repair**
Won't turn on? Logic board issues?  
**Price**: From $199 | **Time**: 2-4 hours

## Why Choose cellrox?

✅ **All Brands** - We fix them all  
✅ **Fast Service** - Same-day available  
✅ **Data Protection** - Your files are safe  
✅ **90-Day Warranty** - On all repairs  
✅ **Free Diagnosis** - Know before you pay  

## Business & Student Discounts

💼 **10% off** for students (with ID)  
💼 **Bulk rates** for businesses

## Book Your Laptop Repair

📍 Inside Walmart, 800 Matheson Blvd West  
⏰ Open Daily 10 AM - 10 PM  
📞 905-699-6599 | 647-997-6390  
🌐 [iphonerepairnearme.ca](https://iphonerepairnearme.ca)

Walk in or book online - we're here to help!
    `
  }
];

export const mockTestimonials = [
  {
    id: 1,
    name: "Sarah Chen",
    rating: 5,
    comment: "Fixed my MacBook Pro screen in 2 hours! Apple wanted $800, cellrox charged $350. Incredible service!",
    date: "1 week ago",
    service: "MacBook Screen Replacement",
    verified: true
  },
  {
    id: 2,
    name: "Michael Johnson",
    rating: 5,
    comment: "Best phone repair in Mississauga! They fixed my water-damaged iPhone 15 Pro. Thought it was dead - they brought it back to life!",
    date: "2 weeks ago",
    service: "Water Damage Repair",
    verified: true
  },
  {
    id: 3,
    name: "Priya Patel",
    rating: 5,
    comment: "Super convenient location inside Walmart. Got my iPad screen fixed while shopping. Professional and fast!",
    date: "1 week ago",
    service: "iPad Screen Repair",
    verified: true
  },
  {
    id: 4,
    name: "David Martinez",
    rating: 5,
    comment: "Their AI chat helped me book instantly. Repaired my Samsung Galaxy in 45 min. Will definitely come back!",
    date: "3 days ago",
    service: "Samsung Repair",
    verified: true
  },
  {
    id: 5,
    name: "Jennifer Wong",
    rating: 5,
    comment: "Laptop wouldn't turn on. They diagnosed and fixed the motherboard same day. Lifesavers! 💯",
    date: "2 weeks ago",
    service: "Laptop Repair",
    verified: true
  },
  {
    id: 6,
    name: "Alex Thompson",
    rating: 5,
    comment: "90-day warranty gave me peace of mind. iPhone battery replacement was quick and affordable. Highly recommend!",
    date: "5 days ago",
    service: "Battery Replacement",
    verified: true
  }
];

export const storeHours = {
  monday: { open: "10:00 AM", close: "10:00 PM" },
  tuesday: { open: "10:00 AM", close: "10:00 PM" },
  wednesday: { open: "10:00 AM", close: "10:00 PM" },
  thursday: { open: "10:00 AM", close: "10:00 PM" },
  friday: { open: "10:00 AM", close: "10:00 PM" },
  saturday: { open: "10:00 AM", close: "10:00 PM" },
  sunday: { open: "10:00 AM", close: "10:00 PM" }
};
